export class BuildingAuthorityType {
  static ALL = new BuildingAuthorityType('ALL', 'All');
  static VIEW = new BuildingAuthorityType('VIEW', 'View');
  static CONTROL_LIGHTS = new BuildingAuthorityType('CONTROL_LIGHTS', 'Temporary Lighting Control');
  static ANALYTICS = new BuildingAuthorityType('ANALYTICS', 'Heatmap');
  static HIGH_RESOLUTION_ANALYTICS = new BuildingAuthorityType('HIGH_RESOLUTION_ANALYTICS', 'High Resolution Heatmap');
  static MANAGE_CIRCADIAN_RHYTHM = new BuildingAuthorityType('MANAGE_CIRCADIAN_RHYTHM', 'Circadian Curves');
  static MANAGE_NODES = new BuildingAuthorityType('MANAGE_NODES', 'Nodes');
  static MANAGE_FLOORS = new BuildingAuthorityType('MANAGE_FLOORS', 'Floors');
  static MANAGE_GATEWAYS = new BuildingAuthorityType('MANAGE_GATEWAYS', 'Gateways');
  static MANAGE_BACNET_AREAS = new BuildingAuthorityType('MANAGE_BACNET_AREAS', 'BACnet Areas');
  static MANAGE_BLUETOOTH_BEACONS = new BuildingAuthorityType('MANAGE_BLUETOOTH_BEACONS', 'Bluetooth Beacons');
  static MANAGE_LIGHTING_CONFIGURATION = new BuildingAuthorityType(
    'MANAGE_LIGHTING_CONFIGURATION',
    'Lighting Configuration'
  );
  static MANAGE_TAGS = new BuildingAuthorityType('MANAGE_TAGS', 'Tags');
  static MANAGE_USERS = new BuildingAuthorityType('MANAGE_USERS', 'Users');
  static MANAGE_TENANT = new BuildingAuthorityType('MANAGE_TENANT', 'Manage Tenants');
  static MANAGE_ROLES = new BuildingAuthorityType('MANAGE_ROLES', 'Roles');
  static MANAGE_BUILDING = new BuildingAuthorityType('MANAGE_BUILDING', 'Building');
  static MANAGE_SCHEDULES = new BuildingAuthorityType('MANAGE_SCHEDULES', 'Schedules');
  static MANAGE_EMERGENCY_LIGHTING = new BuildingAuthorityType('MANAGE_EMERGENCY_LIGHTING', 'Emergency Lighting');
  static MAINTENANCE = new BuildingAuthorityType('MAINTENANCE', 'Maintenance');
  static MANAGE_MAINTENANCE_UPDATES = new BuildingAuthorityType('MANAGE_MAINTENANCE_UPDATES', 'Maintenance Updates');
  static ALL_TOKEN = new BuildingAuthorityType('ALL_TOKEN', 'All token');
  static UNKNOWN = new BuildingAuthorityType('UNKNOWN', 'Unknown');
  static MANAGE_DDL = new BuildingAuthorityType('MANAGE_DDL', 'Manage DDL');
  static VIEW_DASHBOARD_INSIGHTS = new BuildingAuthorityType('VIEW_DASHBOARD_INSIGHTS', 'View Dashboard Insights');
  static VIEW_DASHBOARD_ANALYTICS = new BuildingAuthorityType('VIEW_DASHBOARD_ANALYTICS', 'View Dashboard Metrics');
  static VIEW_ADM_INSIGHTS = new BuildingAuthorityType('VIEW_ADM_INSIGHTS', 'View Driver Metrics');
  static ENROL_NODES = new BuildingAuthorityType('ENROL_NODES', 'Enrol Nodes');
  static MANAGE_AUDIT = new BuildingAuthorityType('MANAGE_AUDIT', 'Audit trail Webhook');

  static fromName(name: string): BuildingAuthorityType {
    return Object.values(BuildingAuthorityType).find((type) => type.name === name);
  }

  static fromString(value: string): BuildingAuthorityType {
    return Object.values(BuildingAuthorityType).find((type) => type.value === value);
  }

  static fromArray(auths: string[]): BuildingAuthorityType[] {
    return auths.map((auth) => BuildingAuthorityType.fromString(auth));
  }

  constructor(public value: string, public name: string) {}

  toString(): string {
    return this.value;
  }

  getName(): string {
    return this.name;
  }
}
